const light = {
  primaryColor: "#23B26D",
  secondaryColor: "#2F6FE0",
  accentColor: "#2F6FE0",
  backgroundcolor: "#F4F6FA",
  headerBackgroundColor: "#FFFFFF",
  shadowColor: "#DCE2ED",
  cardBackgroundColor: "#FFFFFF",
  controlsBackgroundColor: "#EEF1F7",
  borderColor: "#DCE2ED",

  // text
  textDark: "#151B29",
  textMediumDark: "#3D4453",
  textMedium: "#6B7488",
  textMediumLight: "#B7B8BA",
  textLight: "#fff",

  // common
  graphAxle1: "#FFB419",
  graphAxle2: "#8B3AB9",

  //circle graph
  circleBackground: "#F1F3F8",

  //button
  primaryButtonColor: "#D9D9D9",
  primaryInactiveButtonColor: "#ABABAB",
  primaryButtonText: "#3A3A3A",

  // connection/status dot
  okColor: "#23B26D",
  warnColor: "#DB960F",
  critColor: "#DA4B3F",
  offlineColor: "#7B8499",

  // sidebar
  sidebarBackground: "#1E2420",
  sidebarText: "#A7B0A6",
  sidebarActiveBackground: "#2A332C",
};

const dark = {
  primaryColor: "#2ECC71",
  secondaryColor: "#4A90E2",
  accentColor: "#4A90E2",
  backgroundcolor: "#161B26",
  headerBackgroundColor: "#1E2433",
  shadowColor: "#2E3648",
  cardBackgroundColor: "#1E2433",
  controlsBackgroundColor: "#262E40",
  borderColor: "#2E3648",

  // text
  textDark: "#E8ECF4",
  textMediumDark: "#B9C2D6",
  textMedium: "#8993AC",
  textMediumLight: "#B7B8BA",
  textLight: "#fff",

  // common
  graphAxle1: "#FFB419",
  graphAxle2: "#8B3AB9",

  //circle graph
  circleBackground: "#242C3D",

  //button
  primaryButtonColor: "#6d6d73",
  primaryInactiveButtonColor: "#767675",
  primaryButtonText: "#E3E3E3",

  // connection/status dot
  okColor: "#2ECC71",
  warnColor: "#F5A623",
  critColor: "#E74C3C",
  offlineColor: "#7B8499",

  // sidebar
  sidebarBackground: "#12160F",
  sidebarText: "#8F9789",
  sidebarActiveBackground: "#1D2419",
};

export default {
  light,
  dark,
};
